import * as React from "react";
import type { SVGProps } from "react";
const SvgDiscountStar02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="m8.4 15.6 7.2-7.2m-6.646.55-.014-.015m6.124 6.188-.014-.015M9.576 4.043l-1.938-.425a.614.614 0 0 0-.716.414l-.601 1.89a.61.61 0 0 1-.399.399l-1.89.601a.614.614 0 0 0-.414.716l.425 1.938a.61.61 0 0 1-.146.545L2.56 11.587a.614.614 0 0 0 0 .826l1.337 1.466c.134.147.188.35.146.545l-.425 1.938c-.068.31.112.62.414.716l1.89.601c.19.06.339.21.399.399l.601 1.89a.613.613 0 0 0 .716.414l1.938-.425a.61.61 0 0 1 .545.146l1.466 1.337a.613.613 0 0 0 .826 0l1.466-1.337a.61.61 0 0 1 .545-.146l1.938.425c.31.068.62-.112.716-.414l.601-1.89a.61.61 0 0 1 .399-.399l1.89-.601a.613.613 0 0 0 .414-.716l-.425-1.938a.61.61 0 0 1 .146-.545l1.337-1.466a.613.613 0 0 0 0-.826l-1.337-1.466a.61.61 0 0 1-.146-.545l.425-1.938a.614.614 0 0 0-.414-.716l-1.89-.601a.61.61 0 0 1-.399-.399l-.601-1.89a.614.614 0 0 0-.716-.414l-1.938.425a.61.61 0 0 1-.545-.146L12.413 2.56a.614.614 0 0 0-.826 0L10.12 3.897a.61.61 0 0 1-.545.146Z"
    />
  </svg>
);
export default SvgDiscountStar02;
